export const formatDate = (
  dateString: string,
  locale?: string,
  options: any = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }
) => {
  return dateString
    ? new Date(dateString).toLocaleString(locale || 'en', options)
    : '';
};

export const formatDateHourMinute = (dateString: string, locale: string) =>
  formatDate(dateString, locale, { hour: '2-digit', minute: '2-digit' });

export const formatDateDayMonth = (dateString: string, locale: string) =>
  formatDate(dateString, locale, { day: 'numeric', month: 'long' });
